import { RoleService } from '@anecdotes/auth-core';
import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { OwnersModule } from './modules/owners/owners.module';
import { RoleApiService, RoleFacadeService } from './services';
import { effects, featureKey, reducers } from './store';

@NgModule({
  imports: [
    CommonModule,
    OwnersModule,
    StoreModule.forFeature(featureKey, reducers),
    EffectsModule.forFeature(effects),
  ],
})
export class UserManagementCoreModule {
  static forRoot(): ModuleWithProviders<UserManagementCoreModule> {
    return {
      ngModule: UserManagementCoreModule,
      providers: [...OwnersModule.forRoot().providers, RoleFacadeService, RoleService, RoleApiService],
    };
  }
}
